export default "__VITE_ASSET__DZeY2KpM__"